import { render, staticRenderFns } from "./AssignUserModal.vue?vue&type=template&id=56186808&scoped=true&"
import script from "./AssignUserModal.vue?vue&type=script&lang=js&"
export * from "./AssignUserModal.vue?vue&type=script&lang=js&"
import style0 from "./AssignUserModal.vue?vue&type=style&index=0&id=56186808&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56186808",
  null
  
)

export default component.exports